module.exports = __webpack_public_path__ + "img/17843_S.880d0930.png";